import { Box, styled } from '@lingoda/ui';

export const RegisterFormWrapperStyled = styled(Box)(({ theme }) => {
    return {
        alignContent: 'flex-start',
        display: 'grid',
        gridGap: '16px',
        padding: '30px',
        width: '100%',
        background: theme.palette.common.white,
        borderRadius: theme.shape.borderRadius,
        border: `1px solid ${theme.colors.border.strong}`,
        maxWidth: 380,
        margin: '0 auto',
        [theme.breakpoints.down('md')]: {
            maxWidth: '586px',
            position: 'relative',
            flex: 'none',
        },
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(4, 3, 3),
            margin: 0,
            maxWidth: 'none',
        },
    };
});
